import { filter, find, findIndex, orderBy } from 'lodash';
import { observable, action, makeObservable } from 'mobx'
import IWebsiteGroup from '../interfaces/IWebsiteGroup';

export default class WebsiteGroupStore {

     list: IWebsiteGroup[] = [];

    
    addRecords(records: IWebsiteGroup[]): any {
        if (records.length > 0) {
            records.forEach((record: IWebsiteGroup) => this.addRecord(record));
        }
    }

    
    private addRecord(record: IWebsiteGroup) {
        if (!record) {
            return;
        }

        const index = findIndex(this.list, { id: record.id });
        if (index >= 0) {
            this.list.splice.apply(this.list, [index, 1, record]);
        } else {
            this.list.push(record);
        }
    }

    public getById(id: string): IWebsiteGroup {
        return find(this.list, { id: id });
    }

    public getByIds(ids: string[]): IWebsiteGroup[] {
        return filter(this.list, item => {
            if (ids.includes(item.id)) {
                return true;
            }
            return false;
        })
    }

    public getByUserId(userId: string): IWebsiteGroup[] {
        return this.orderByName(filter(this.list, { userId: userId }));
    }

    private orderByName(sections: IWebsiteGroup[]): IWebsiteGroup[] {
        return orderBy(sections, ['name'], ['asc']);
    }

    public removeById(id: string) {
        this.list = filter(this.list, item => {
            if (item.id != id) {
                return true;
            }
            return false;
        })
    }

    constructor() {
        makeObservable(this, {
            list: observable,
            addRecords: action,
            removeById: action,
        })
    }
}